import { IFormContractRequest } from '../interfaces/formContractRequest';
import { IFileWithAttachRequest } from '../interfaces/fileWithAttachRequest';
import { IShadowGenericContractCreate } from '../interfaces/shadowGenericContractCreate';
import { IShadowRepresentativeCreate } from '../interfaces/shadowRepresentativeCreate';
import { IShadowCustomerCreate } from '../interfaces/shadowCustomerCreate';
import { IShadowSitePodCatalogs } from '../interfaces/shadowSitePodCatalogs';
import { IShadowSitePdrCatalogs } from '../interfaces/shadowSitePdrCatalogs';
import { IFormContractResponse } from '../interfaces/formContractResponse';
import { fillArray, fillArrayWithCast } from './_models.helper';
import { FormContractResponse } from './formContractResponse';
import { ShadowStorageFileAttach } from './shadowStorageFileAttach';
import { ShadowSitePdrCatalogs } from './shadowSitePdrCatalogs';
import { ShadowSitePodCatalogs } from './shadowSitePodCatalogs';
import { FileWithAttachRequest } from './fileWithAttachRequest';
import { ShadowCustomerCreate } from './shadowCustomerCreate';
import { ShadowGenericContractCreate } from './shadowGenericContractCreate';
import { ShadowRepresentativeCreate } from './shadowRepresentativeCreate';
import { PhaseContract } from '../enums/phaseContract.enum';

export class FormContractRequest implements IFormContractRequest {
    files: IFileWithAttachRequest[] = new Array<IFileWithAttachRequest>();
    contract: IShadowGenericContractCreate = new ShadowGenericContractCreate();
    representative: IShadowRepresentativeCreate = new ShadowRepresentativeCreate();
    client: IShadowCustomerCreate = new ShadowCustomerCreate();
    idAgent: number;
    pods: IShadowSitePodCatalogs[] = new Array<IShadowSitePodCatalogs>();
    pdrs: IShadowSitePdrCatalogs[] = new Array<IShadowSitePdrCatalogs>();
    validateAs: PhaseContract;


    constructor(cr?: IFormContractRequest | IFormContractResponse) {
        // console.log(`FormContractRequest constructor`);
        if (cr) {
            // console.log("ARG EXISTS", cr);
            if (cr instanceof FormContractRequest) {
                // console.log("instanceof FormContractRequest");
                this.files = fillArray<FileWithAttachRequest>(cr.files, FileWithAttachRequest);
                this.contract = new ShadowGenericContractCreate(cr.contract);
                this.representative = new ShadowRepresentativeCreate(cr.representative);
                this.client = new ShadowCustomerCreate(cr.client);
                this.idAgent = cr.idAgent;
                this.pods = fillArray(cr.pods, ShadowSitePodCatalogs);
                this.pdrs = fillArray(cr.pdrs, ShadowSitePdrCatalogs);
                this.validateAs = cr.validateAs;
            } else if (cr instanceof FormContractResponse) {
                // console.log("instanceof FormContractResponse");
                this.files = fillArrayWithCast(
                    cr.files,
                    ShadowStorageFileAttach,
                    FileWithAttachRequest.FromShadowStorageFileAttach
                );
                this.contract = new ShadowGenericContractCreate(cr.contract);
                this.representative = new ShadowRepresentativeCreate(cr.representative);
                this.client = new ShadowCustomerCreate(cr.client);
                this.idAgent = cr.agent.id;
                this.pods = fillArray(cr.pods, ShadowSitePodCatalogs);
                this.pdrs = fillArray(cr.pdrs, ShadowSitePdrCatalogs);
            }
        }
        // console.log("FormContractRequest CONSTRUCTOR ", this);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/formContractRequest.ts